'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _laws = require('../actions/laws');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchLaws),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchLawsRequest),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(updateLawDate),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(updateLawDateRequest);

function fetchLaws() {
    var response, laws;
    return regeneratorRuntime.wrap(function fetchLaws$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/laws');

                case 3:
                    response = _context.sent;
                    laws = response.data.reduce(function (aggr, law) {

                        aggr[law.id] = law;
                        return aggr;
                    }, {});
                    _context.next = 7;
                    return (0, _effects.put)(_laws.actionCreators.fetchLawsSucceeded(laws));

                case 7:
                    _context.next = 13;
                    break;

                case 9:
                    _context.prev = 9;
                    _context.t0 = _context['catch'](0);
                    _context.next = 13;
                    return (0, _effects.put)(_laws.actionCreators.fetchLawsFailed(_context.t0));

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 9]]);
}

function fetchLawsRequest() {
    return regeneratorRuntime.wrap(function fetchLawsRequest$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(_laws.actionTypes.FETCH_LAWS_REQUEST, fetchLaws);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function updateLawDate(action) {
    var response;
    return regeneratorRuntime.wrap(function updateLawDate$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/laws/' + action.id, { lastUpdatedAt: action.lastUpdatedAt });

                case 3:
                    response = _context3.sent;
                    _context3.next = 6;
                    return (0, _effects.put)(_laws.actionCreators.updateLawDateSucceeded(response.data));

                case 6:
                    _context3.next = 12;
                    break;

                case 8:
                    _context3.prev = 8;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 12;
                    return (0, _effects.put)(_laws.actionCreators.updateLawDateFailed(_context3.t0));

                case 12:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 8]]);
}

function updateLawDateRequest() {
    return regeneratorRuntime.wrap(function updateLawDateRequest$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(_laws.actionTypes.UPDATE_LAW_DATE_REQUEST, updateLawDate);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

exports.default = [fetchLawsRequest, updateLawDateRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/laws.js
// module id = 2224
// module chunks = 0